import { render, staticRenderFns } from "./ModalThanTaiBanSo.vue?vue&type=template&id=76750d52&scoped=true&"
import script from "./ModalThanTaiBanSo.vue?vue&type=script&lang=js&"
export * from "./ModalThanTaiBanSo.vue?vue&type=script&lang=js&"
import style0 from "./ModalThanTaiBanSo.vue?vue&type=style&index=0&id=76750d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76750d52",
  null
  
)

export default component.exports